import { render } from "./RegistrationWarningModal.vue?vue&type=template&id=e9f3410e"
import script from "./RegistrationWarningModal.vue?vue&type=script&lang=js"
export * from "./RegistrationWarningModal.vue?vue&type=script&lang=js"

import "./RegistrationWarningModal.vue?vue&type=style&index=0&id=e9f3410e&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__